import React, { FC } from 'react';
import { View } from 'react-native';
import HeaderTwo from '../HeaderTwo';
import styles from './styles';

export type SplashScreenProps = {
  text?: string;
};

export const SplashScreen: FC<SplashScreenProps> = ({ text }) => {
  const loadingText = text || 'Loading ...';
  return (
    <View style={styles.container}>
      <HeaderTwo title={loadingText} />
    </View>
  );
};

export default SplashScreen;
